import React from 'react';
import LinkButton from '../atoms/LinkButton';
import { activeOffer } from '../../data/activeOffer';
import { facts } from '../../data/facts';
import { homeMethodology } from '../../data/methodology';

const PlayTrackBand = () => (
  <section
    className="py-12 md:py-16 bg-navy text-white"
    aria-labelledby="play-track-band-heading"
  >
    <div className="dr-container">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="text-sm font-bold uppercase tracking-wide text-yellow mb-3">
            Play → Analyze → Create
          </p>
          <h2 id="play-track-band-heading" className="text-3xl md:text-4xl font-black mb-4">
            From the field to the data
          </h2>
          <p className="text-lg text-white/90 mb-4 max-w-prose">
            {homeMethodology.subtitle} {facts.ageSentence}
          </p>
          <LinkButton to={activeOffer.destination} variant="primary" className="text-lg py-3 px-6">
            {activeOffer.label}
          </LinkButton>
        </div>

        <div className="relative w-full max-w-lg mx-auto lg:mx-0 lg:ml-auto">
          <svg
            className="w-full h-auto dr-track-band__svg"
            viewBox="0 0 400 140"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              className="dr-track-band__path dr-track-band__path--sky"
              d="M 40 70 Q 120 20 200 70 T 360 70"
              fill="none"
              stroke="#4CBCE4"
              strokeWidth="2"
              strokeLinecap="round"
              opacity="0.35"
            />
            <path
              className="dr-track-band__path dr-track-band__path--yellow"
              d="M 40 70 Q 120 20 200 70 T 360 70"
              fill="none"
              stroke="#FFCD07"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="10 14"
            />
            {homeMethodology.steps.map((step, index) => {
              const x = 40 + index * 160;
              return (
                <g key={step.id} transform={`translate(${x}, 70)`}>
                  <circle r="22" fill="#0c172C" stroke="#FFCD07" strokeWidth="2" />
                  <circle className="dr-track-band__node" r="8" fill="#FFCD07" opacity="0.9" />
                  <text
                    y="42"
                    textAnchor="middle"
                    fill="#FFCD07"
                    fontSize="11"
                    fontWeight="700"
                    fontFamily="Nunito Sans, sans-serif"
                  >
                    {step.title}
                  </text>
                </g>
              );
            })}
          </svg>
        </div>
      </div>
    </div>
  </section>
);

export default PlayTrackBand;
